/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Matrix_OverlineInputs */

const en_hub_matrix_overline = /** @type {(inputs: Hub_Matrix_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coverage`)
};

const id_hub_matrix_overline = /** @type {(inputs: Hub_Matrix_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cakupan`)
};

/**
* | output |
* | --- |
* | "Coverage" |
*
* @param {Hub_Matrix_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_matrix_overline = /** @type {((inputs?: Hub_Matrix_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Matrix_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_matrix_overline(inputs)
	return en_hub_matrix_overline(inputs)
});